var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreativeProcessMonochromatic57Cda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 669.65 490.68",
    "data-imageid": "creative-process-monochromatic-57cda",
    imageName: "Creative Process",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 161.7,
    y1: 320.02,
    x2: 394.56,
    y2: 320.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 286.14,
    y1: 184,
    x2: 405.65,
    y2: 184,
    gradientTransform: "matrix(0.93, 0.37, -0.37, 0.93, 189.19, 40.85)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 300.1,
    y1: 176.68,
    x2: 324.77,
    y2: 105.06,
    gradientTransform: "translate(57.75 6.79) rotate(7.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 382.3,
    y1: 212.78,
    x2: 444.71,
    y2: 271.17,
    gradientTransform: "translate(57.75 6.79) rotate(7.09)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 290.33,
    y1: 150.69,
    x2: 317.05,
    y2: 150.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 272.27,
    y1: 84.78,
    x2: 344.67,
    y2: 84.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 303.97,
    y1: 118.59,
    x2: 315.67,
    y2: 173.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 297.74,
    y1: 145.96,
    x2: 337.84,
    y2: 97.94,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Creative process 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M215.18,34.83C193.79,44.48,173.25,57.11,158.1,75c-20.95,24.76-30.28,57.94-52.26,81.79-28.1,30.49-74.3,43-94.7,79.06C3.37,249.63.25,265.54-1.09,281.29-6.2,341.22,17,406.74,68.62,437.63c20.5,12.26,44.11,18.5,64.85,30.36,18.42,10.53,34.45,25.43,54.25,33.05,34.93,13.43,74.48,1.66,107.9-15.17S360.53,447,396.93,438.29c47-11.18,96,1.3,144.26,1.86s103.94-17.27,120.14-62.76c5.08-14.27,5.61-29.69,6.08-44.83.88-28.36,1.61-57.66-9-84C644,212.45,609.9,186.25,598.33,149.1c-6.1-19.61-5.66-41.57-16.38-59.09-14.1-23.07-43.37-31.7-70.31-34C468.86,52.32,423,59.16,385.2,38.75,330.86,9.4,271.69,9.32,215.18,34.83Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    },
    className: "target-color"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.48,319.1a8,8,0,0,0-.17-2v0l20.25-3.23-5.38-44L362.71,274a90,90,0,0,0-19.2-23.52l-.05,0,13.59-20.06V219L321.31,204.2l-17.53,25.67a86.05,86.05,0,0,0-20.87-2.5,5.85,5.85,0,0,0-1.66.16l-7.94-27.8-43-.76v11.37l8,28.6a92.32,92.32,0,0,0-26.08,21.4L189.69,245.7l-25.44,24.91V282L193,300.76a94.34,94.34,0,0,0-1.83,18.34,38.84,38.84,0,0,0,.34,6.36l-29.81-4v11.37l9,43.36,34.49-8.38h0a91.06,91.06,0,0,0,13.22,16.74l-15.4,17.05V413L241.2,435.5,256.79,407h0a91.36,91.36,0,0,0,24.6,3.85h0l10.88,30.23,42.2-13.47V416.23l-9.59-15.6h0a89.54,89.54,0,0,0,21-15l20.8,13L391.59,362V350.63l-21.94-2.48A88.75,88.75,0,0,0,374.48,319.1Zm-91.57,45.2a45.2,45.2,0,1,1,45-45.2A45.22,45.22,0,0,1,282.91,364.3Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.48,307.74a8,8,0,0,0-.17-2v0l20.25-3.23-5.38-44-26.47,4.13a90.16,90.16,0,0,0-19.2-23.53l-.05,0L357.05,219l-35.74-26.17L303.78,218.5a86.55,86.55,0,0,0-20.87-2.5,5.52,5.52,0,0,0-1.66.17l-7.94-27.8-43,10.6,8,28.6A92.18,92.18,0,0,0,212.27,249l-22.58-14.64-25.44,36.27L193,289.39a94.36,94.36,0,0,0-1.83,18.35,38.84,38.84,0,0,0,.34,6.36l-29.81,7.36,9,43.37,34.49-8.39h0a90.72,90.72,0,0,0,13.22,16.74l-15.4,28.42,38.14,22.52,15.59-28.5h0a91.36,91.36,0,0,0,24.6,3.85h0l10.88,30.22,42.2-13.47-9.59-27h0a89.21,89.21,0,0,0,21-15l20.8,13,24.86-36.66-21.94-13.85A88.64,88.64,0,0,0,374.48,307.74Zm-91.57,45.2a45.2,45.2,0,1,1,45-45.2A45.23,45.23,0,0,1,282.91,352.94Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M489.37,356.89a4.18,4.18,0,0,0,.29-1h0l10.27,2.27,5.73-22-13.41-3a46.19,46.19,0,0,0-4.72-14.85l0,0,10.27-7,2.14-5.43L485.67,292,472.46,301a44.58,44.58,0,0,0-9.49-5.13,2.86,2.86,0,0,0-.82-.23l1.45-14.77-20.38-8.48-2.15,5.43-1.55,15.17A47.37,47.37,0,0,0,423,298.23L415,287l-16.84,7.09L396,299.49l10.18,14.39a48.38,48.38,0,0,0-4.34,8.42,20.06,20.06,0,0,0-1,3.09l-13.47-7.53-2.14,5.42-3.87,22.41,18,2.5h0a46.78,46.78,0,0,0,3.16,10.49L392,363.92l-2.14,5.42,14,18,12.82-10.66h0a46.8,46.8,0,0,0,11,6.48h0l-.52,16.48,22.69,1.53,2.14-5.42-1.63-9.26h0a46,46,0,0,0,12.85-3.19l7.47,10.14,18.79-12.81,2.14-5.43-10-5.32A45.78,45.78,0,0,0,489.37,356.89Zm-52.24,4.29a23.2,23.2,0,1,1,30-13.07A23.2,23.2,0,0,1,437.13,361.18Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M491.51,351.47a4.14,4.14,0,0,0,.3-1h0l10.28,2.28,5.73-22-13.41-3a46.62,46.62,0,0,0-4.73-14.85v0l10.26-7-12.12-19.23-13.2,8.94a44.62,44.62,0,0,0-9.49-5.13,3.31,3.31,0,0,0-.83-.24l1.46-14.76-22.53-3.06-1.55,15.17a47.32,47.32,0,0,0-16.49,5.3l-8-11.25-19,12.51,10.17,14.39a49.31,49.31,0,0,0-4.33,8.41,20.53,20.53,0,0,0-1,3.1l-15.62-2.11-3.87,22.4,18.05,2.51h0a46.52,46.52,0,0,0,3.15,10.48L392,363.92l14,17.95,12.82-10.67h0a47,47,0,0,0,11,6.49h0l-.51,16.48L452,395.71l.51-14.68h0a46.46,46.46,0,0,0,12.86-3.19L472.8,388l18.78-12.81-7.86-10.74A45.46,45.46,0,0,0,491.51,351.47Zm-52.24,4.29a23.2,23.2,0,1,1,30-13.08A23.22,23.22,0,0,1,439.27,355.76Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M344.2,199a32.79,32.79,0,0,0-12.25-.4,3.57,3.57,0,0,0-2.6,1.26,2.48,2.48,0,0,0,.13,2.62,6.22,6.22,0,0,0,2,1.83c5.66,3.54,12.43,4.76,19,5.9a2.2,2.2,0,0,0,1.11,0c.68-.25.93-1.07,1.08-1.79l2.06-9.72a1.56,1.56,0,0,0,0-.83,1.44,1.44,0,0,0-.44-.6c-1.32-1.23-4.79-3.24-6.63-2.08S347.1,199.65,344.2,199Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M344.2,199a32.79,32.79,0,0,0-12.25-.4,3.57,3.57,0,0,0-2.6,1.26,2.48,2.48,0,0,0,.13,2.62,6.22,6.22,0,0,0,2,1.83c5.66,3.54,12.43,4.76,19,5.9a2.2,2.2,0,0,0,1.11,0c.68-.25.93-1.07,1.08-1.79l2.06-9.72a1.56,1.56,0,0,0,0-.83,1.44,1.44,0,0,0-.44-.6c-1.32-1.23-4.79-3.24-6.63-2.08S347.1,199.65,344.2,199Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-3)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M445.42,76.76s10.87,6.73,12.07,8.07S445,155.25,444.27,158.62s-20-3.13-27.85-5.84-15.13-15.66-15.13-15.66,8.81-59.48,10.57-60.52S429.7,73,429.7,73Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M415,75.57s-4.11.56-6.44,2.57-22.35,27.42-21.28,33.52,7.37,8.85,9.51,8,7.34-8.37,8.35-10.59,14.77-19.71,14.77-19.71Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M446.93,70s-2.11,7.28-1.7,10.15S440.66,90.72,435,90.4s-5.14-10-5.07-11.09,1.79-1.6,1.38-4.47S446.56,66.59,446.93,70Z",
    transform: "translate(1.78 -16.19)",
    fill: "#f5e0cd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M431.3,74.84a4.41,4.41,0,0,1-1.12,3.77,7.11,7.11,0,0,0,4.55,2.32c3.41.19,8.67-2.36,11.22-7.34l.14-.27c.43-1.86.84-3.3.84-3.3C446.56,66.59,430.9,72,431.3,74.84Z",
    transform: "translate(1.78 -16.19)",
    fill: "#efd2bb"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M445.18,79.1S440,89.55,436.05,90.46c0,0-1.09.51,1.65,2.37s11.15-6.2,10.37-12.51a4.67,4.67,0,0,0-2.63-3.77Z",
    transform: "translate(1.78 -16.19)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M431.24,76s-1.7,7.8,1.18,13.4c0,0-1.47,1.95-2.6,1.88s-3.59-7-2.17-12.06C428.48,76.24,430.72,75.13,431.24,76Z",
    transform: "translate(1.78 -16.19)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M457.63,123",
    transform: "translate(1.78 -16.19)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.43
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M443.7,158.59l-4.2,44.71L434,271.82s-3,2.68-10.33,1.7l-2.76-73-6.81-33.69L377,161.29a5.45,5.45,0,0,0-6.85,3L355,199.88s-5.95-2.77-9.6-4.12l12.53-49.56a8.16,8.16,0,0,1,10.14-5.85l35.57-2.93Z",
    transform: "translate(1.78 -16.19)",
    fill: "#606161"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M429.14,52.53s-2,14.68-1.05,18.72,4.13,7.62,7.53,7.81,8.67-2.36,11.22-7.34,4.38-17.39,3.91-19.12-3.6-7.29-12.7-7C431.78,45.85,429.26,50.26,429.14,52.53Z",
    transform: "translate(1.78 -16.19)",
    fill: "#f5e0cd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M434.47,48.07l-1.13,2.47a1.56,1.56,0,0,1-1.86,1.09c-.78,0-1.56,0-2.34-.08a1.47,1.47,0,0,1-.82-.23c-.59-.48-.75-1.82-1.09-2.5a5.37,5.37,0,0,1-.94-2.9,3.71,3.71,0,0,1,.65-1.61,6.77,6.77,0,0,1,2.11-2,7.13,7.13,0,0,0,1.05-.66,6.92,6.92,0,0,0,1.09-1.47,7.19,7.19,0,0,1,9.91-2c.94.61,1.94,1.5,3,1.22.39-.1.73-.34,1.11-.47a4,4,0,0,1,1.87,0,11.25,11.25,0,0,1,4.37,1.42c1.71,1.15,2.65,3.14,4.1,4.6,1.1,1.1,2.49,1.9,3.49,3.08s1.54,3,.64,4.28c-.77,1.08-2.34,1.41-3,2.56-.32.55-.37,1.22-.68,1.78a6.82,6.82,0,0,1-1.3,1.39,8,8,0,0,0-1.18,2.05,22.54,22.54,0,0,1-1.77,2.57c-.3.38-.69.8-1.17.74s-.85-.81-.94-1.42a49.11,49.11,0,0,1-.53-5.93,5.44,5.44,0,0,0-.24-1.85,4.73,4.73,0,0,0-1.75-2,23.21,23.21,0,0,0-7.85-3.82c-.81-.22-1.63-.39-2.45-.61a2.93,2.93,0,0,0-2.25,0",
    transform: "translate(1.78 -16.19)",
    fill: "#606161"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M449.08,62.18s.75-3.37,3-2.11-1,7.34-2.14,7.84a3.32,3.32,0,0,1-1.72.39",
    transform: "translate(1.78 -16.19)",
    fill: "#f5e0cd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M373,135.92a3,3,0,0,0,.07,1.71,2.49,2.49,0,0,0,1.07,1.06c3.1,1.86,7.26.81,10.08-1.44s4.66-5.48,6.59-8.54c1.71-2.7,3.54-5.33,5.49-7.86.73-1,1.52-2.15,1.08-3.27a3.43,3.43,0,0,0-.87-1.14c-6.4-6.28-2.74-15.4-8.33-8.5C383.79,113.32,374.07,129.07,373,135.92Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M365.57,136.4a6.33,6.33,0,0,0-2.38,3.9c-.15,1.55,1,3.28,2.59,3.19a5.94,5.94,0,0,0,1.92-.67c1.93-.81,4.09-.72,6.17-.86s4.33-.62,5.69-2.2a4.72,4.72,0,0,0,.82-4.61C378,128.6,368.91,133.39,365.57,136.4Z",
    transform: "translate(1.78 -16.19)",
    fill: "#f5e0cd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M422.84,279.73a43.93,43.93,0,0,0-3.94,5.08,13,13,0,0,0-2.06,4.28,3.88,3.88,0,0,0,0,2.11,3.31,3.31,0,0,0,2.11,1.92,7.36,7.36,0,0,0,2.92.25,20.67,20.67,0,0,0,10.81-4,8.2,8.2,0,0,0,2.69-3,7.45,7.45,0,0,0,.14-4.74c-.39-1.56-1-3.05-1.49-4.6s-.67-3.23-1-4.84a.57.57,0,0,0-.6-.54c-2-.28-5.38-.47-6.64,1.57a9.17,9.17,0,0,0-.84,2.66A8.38,8.38,0,0,1,422.84,279.73Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M422.82,280a44.89,44.89,0,0,0-3.95,5.08,13.23,13.23,0,0,0-2.06,4.28,4,4,0,0,0,0,2.11,3.33,3.33,0,0,0,2.11,1.92,7.36,7.36,0,0,0,2.92.25,20.67,20.67,0,0,0,10.81-4,8,8,0,0,0,2.69-3.05,7.32,7.32,0,0,0,.14-4.74c-.39-1.56-1.05-3-1.49-4.6s-.66-3.23-1-4.84a.73.73,0,0,0-.16-.37.74.74,0,0,0-.44-.16c-2.05-.29-5.38-.48-6.64,1.56a9.93,9.93,0,0,0-.84,2.66A8.45,8.45,0,0,1,422.82,280Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-4)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M465.5,91.8c4.2,5,5.7,7.23,9.66,12.43.25-11.55,3.08-20.23,3.33-31.78a2.19,2.19,0,0,1,.58-1.77,2.1,2.1,0,0,1,1.38-.28,33.58,33.58,0,0,1,7.33,1,2.06,2.06,0,0,1,1.21.63,2.14,2.14,0,0,1,.24,1.42q-1.07,16.06-2.12,32.12a83.52,83.52,0,0,1-1.92,15.13c-.6,2.34-1.59,4.85-3.76,5.92-2.81,1.38-6.12-.31-8.64-2.17-8.06-5.92-14.38-13.84-20.6-21.67a7.62,7.62,0,0,1-1.53-2.52,7.94,7.94,0,0,1,0-3.53c.48-3.14.32-12.16,4.54-12.61C458.93,83.78,463.48,89.38,465.5,91.8Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M476.86,65.21c-.18-2.33-.33-4.81.76-6.88a12.62,12.62,0,0,0,.74-1.41,6,6,0,0,0,.3-1.9c.13-2.94.16-6,1.38-8.68.23-.51.61-1.07,1.17-1.08s1.06.82,1.22,1.5a33.24,33.24,0,0,1,.86,6.81,1.76,1.76,0,0,0,.3,1.16,1.53,1.53,0,0,0,.69.39,7,7,0,0,1,2.85,1.29c.43.43.69,1,1.1,1.45a11.32,11.32,0,0,0,1.5,1.16A6.55,6.55,0,0,1,492,63.59a11.65,11.65,0,0,1-.87,5.14c-.68,1.78-1.75,3.59-3.54,4.25a8.08,8.08,0,0,1-3.79.13C479.41,72.55,477.18,69.53,476.86,65.21Z",
    transform: "translate(1.78 -16.19)",
    fill: "#f5e0cd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M290.33,147.5s2.71,5.23,4.45,6,16.59.83,18,.19,4.26-6.45,4.26-6.45Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M290.33,147.5s2.71,5.23,4.45,6,16.59.83,18,.19,4.26-6.45,4.26-6.45Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-5)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74,122a2.09,2.09,0,0,0-.05.91c.91,4.69-26.33,27.59-35.47,1.82a42.72,42.72,0,0,1-1.77-6.83s-23.91-49.43-7.32-71S331.75,28,343.06,57.47C351.45,79.27,324.4,114.41,322.74,122Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M322.74,122a2.09,2.09,0,0,0-.05.91c.91,4.69-26.33,27.59-35.47,1.82a42.72,42.72,0,0,1-1.77-6.83s-23.91-49.43-7.32-71S331.75,28,343.06,57.47C351.45,79.27,324.4,114.41,322.74,122Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-6)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M322.69,122.88c.91,4.69-26.33,27.59-35.47,1.82A38.42,38.42,0,0,1,322.74,122,2.09,2.09,0,0,0,322.69,122.88Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-7)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M288.44,133a2.24,2.24,0,0,1,.24,1.18,2.46,2.46,0,0,1-.58,1A5,5,0,0,0,288,141c-1.94.5-2.37,3.32-1.2,4.94s3.24,2.27,5.19,2.71a55,55,0,0,0,23.42.21c3-.62,6.27-1.84,7.3-4.69a6.48,6.48,0,0,0-2-2.07c.89-1,1.8-2.49.95-3.5-.28-.34-.71-.53-1-.84a2.77,2.77,0,0,1-.15-3,8.63,8.63,0,0,0,1.08-2.95,2.88,2.88,0,0,0-2.39-2.86c-7.05,2.8-14.91,5.62-22,3C293.89,130.65,285.24,124.55,288.44,133Z",
    transform: "translate(1.78 -16.19)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M288.44,133a2.24,2.24,0,0,1,.24,1.18,2.46,2.46,0,0,1-.58,1A5,5,0,0,0,288,141c-1.94.5-2.37,3.32-1.2,4.94s3.24,2.27,5.19,2.71a55,55,0,0,0,23.42.21c3-.62,6.27-1.84,7.3-4.69a6.48,6.48,0,0,0-2-2.07c.89-1,1.8-2.49.95-3.5-.28-.34-.71-.53-1-.84a2.77,2.77,0,0,1-.15-3,8.63,8.63,0,0,0,1.08-2.95,2.88,2.88,0,0,0-2.39-2.86c-7.05,2.8-14.91,5.62-22,3C293.89,130.65,285.24,124.55,288.44,133Z",
    transform: "translate(1.78 -16.19)",
    fill: "url(#linear-gradient-8)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M311.68,132.12l-2.41-.59,3-12c5.59-22.7,4.63-27.94,3.56-29-.08-.08-.18-.18-.54-.1A3,3,0,0,0,314,91a12.76,12.76,0,0,1,1.57,3.65c.63,2.52.2,4.56-1.17,5.61a2.59,2.59,0,0,1-3,.34c-1.7-1-2-4-1.65-6.41a9.54,9.54,0,0,1,1.14-3.25,4.18,4.18,0,0,0-2.27-1.39c-1.14-.22-2.26.55-3.32,2.2a21.39,21.39,0,0,0-1.12,2c2.36,2.19,3.81,6.19,2.74,8.19a2.3,2.3,0,0,1-2.31,1.42,3.83,3.83,0,0,1-3.19-2.17c-.51-.93-1.31-3.1-.28-6.46-.78-.23-1.81-.06-3,1.6-3.57,4.89,1.32,26.81,3.5,34.84l-2.38.65c-.84-3.07-8-30.22-3.12-37,2.19-3,4.47-3,5.95-2.43a19.66,19.66,0,0,1,1.15-2c2-3.19,4.28-3.57,5.8-3.31a6.39,6.39,0,0,1,3.47,2,5.55,5.55,0,0,1,2.32-1.11,2.94,2.94,0,0,1,2.83.81c1.78,1.84,3.05,7.06-2.94,31.37Zm-8.47-35.73a5.24,5.24,0,0,0,.32,3.59c.36.65.8.88,1,.88h0C305,100.13,304.42,98,303.21,96.39Zm9.24-3a6.68,6.68,0,0,0-.31,1.21c-.36,2.11.14,3.64.46,3.88,0,0,.1-.05.26-.17.53-.4.63-1.59.27-3A10.14,10.14,0,0,0,312.45,93.34Z",
    transform: "translate(1.78 -16.19)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeProcessMonochromatic57Cda);
export default __webpack_public_path__ + "static/media/creative-process-monochromatic-57cda.d1443962b4b2cb138d60804344a4eeea.svg";
export { ForwardRef as ReactComponent };